import FJActionConstant from "../../constant/FJActionConstant";
import FJCanvasStore from "../../store/FJCanvasStore";
import _ from 'lodash'
import FJProjectAction from "./FJProject.action";

let FJExportPreviewAction = (function () {

  return {

    /**
     * @description 播放/暂停输出预览
     * @return {(function(*, *): void)|*}
     */
    toggleExportPreviewPlayAction: function (toggle) {
      return (dispatch, getState) => {
        const {PLAY, PAUSE, HAS_EXPORT_PREVIEW, GET_EXPORT_PREVIEW_DURATION} = FJCanvasStore.command;
        if (FJCanvasStore.executeSync(HAS_EXPORT_PREVIEW)) {
          const allDuration = FJCanvasStore.executeSync(GET_EXPORT_PREVIEW_DURATION, true);
          const shouldPlay = _.isUndefined(toggle) ? !getState().exportPreview.isPlaying : toggle;
          if (shouldPlay) {
            FJCanvasStore.executeSync(PLAY, (isPlaying, progress) => {
              if (!isPlaying) {
                dispatch(this.seekExportPreviewAction('start', 0));
                dispatch(this.seekExportPreviewAction('change', 0));
                dispatch(this.seekExportPreviewAction('end', 0));
                dispatch(this.updateExportPreviewPlayAction(false));
              } else {
                dispatch(this.updateExportPreviewCurrentTimeAction(allDuration * progress));
              }
            });
            dispatch(this.updateExportPreviewPlayAction(true));
          } else {
            FJCanvasStore.executeSync(PAUSE);
            dispatch(this.updateExportPreviewPlayAction(false));
          }
        }
      };
    },

    /**
     * @description 设置输出预览进度
     * @param type
     * @param progress
     */
    seekExportPreviewAction: function (type, progress) {
      return (dispatch) => {
        const {SEEK, GET_EXPORT_PREVIEW_DURATION, HAS_EXPORT_PREVIEW} = FJCanvasStore.command;
        if (FJCanvasStore.executeSync(HAS_EXPORT_PREVIEW)) {
          const allDuration = FJCanvasStore.executeSync(GET_EXPORT_PREVIEW_DURATION);
          const curTime = progress * allDuration;
          console.log(progress);
          FJCanvasStore.execute(SEEK, type, curTime, false, true).catch(e => console.log(e));
          dispatch(this.updateExportPreviewCurrentTimeAction(curTime));
        }
      };
    },

    /**
     * @description 设置全局音量
     * @param volume
     * @param options
     * @param options.shouldCache
     * @param options.useCache
     * @return {(function(*): void)|*}
     */
    setGlobalVolumeAction: function (volume, options) {
      return (dispatch) => {
        if (!isNaN(volume)) {
          FJCanvasStore.executeSync(FJCanvasStore.command.SET_EXPORT_PREVIEW_GLOBAL_VOLUME, volume, options);
          dispatch(this.updateExportPreviewVolume(volume));
        }
      };
    },

    /**
     * @description 更新音量
     * @param volume
     * @returns {{volume, type: string}}
     */
    updateExportPreviewVolume: function (volume) {
      return {
        type: FJActionConstant.UPDATE_EXPORT_PREVIEW_VOLUME,
        volume
      }
    },

    /**
     * @description 更新当前时间
     * @param currentTime
     * @return {{currentTime, type: string}}
     */
    updateExportPreviewCurrentTimeAction: function (currentTime) {
      return {
        type: FJActionConstant.UPDATE_EXPORT_PREVIEW_CURRENT_TIME,
        currentTime,
      }
    },

    /**
     * @description 获取并更新输出预览时长
     */
    updateExportPreviewDurationAction: function () {
      return (dispatch) => {
        let exportPreviewDuration = FJCanvasStore.executeSync(FJCanvasStore.command.GET_EXPORT_PREVIEW_DURATION);
        dispatch(this.setExportPreviewDurationAction(exportPreviewDuration));
      };
    },

    /**
     * @description 更新输出预览时长
     */
    setExportPreviewDurationAction: function (duration) {
      return {
        type: FJActionConstant.SET_EXPORT_PREVIEW_DURATION,
        duration,
      }
    },

    /**
     * @description 更新输出预览的播放状态
     * @param isPlaying
     * @return {{isPlaying, type: string}}
     */
    updateExportPreviewPlayAction: function (isPlaying) {
      return {
        type: FJActionConstant.UPDATE_EXPORT_PREVIEW_PLAYING,
        isPlaying,
      }
    },

    /**
     * @description 停用入场预览
     * @param viewSize
     * @return {(function(*): void)|*}
     */
    disableIntroAction: function (viewSize) {
      return (dispatch) => {
        const {DISABLE_INTRO} = FJCanvasStore.command;
        FJCanvasStore.executeSync(DISABLE_INTRO, viewSize);
        dispatch(this.updateExportPreviewDurationAction());
        dispatch(FJProjectAction.updateGraphsUrlAction());
      };
    },
  }
})();

export default FJExportPreviewAction;
